import { defineAction } from '~/prix'
import { z } from 'zod'
import llmChatListAction from './llmChatList.action.json' assert { type: 'json' }

const llmChatListDefinition = defineAction({
  ...llmChatListAction,

  input: z.object({
    limit: z.number().min(1).max(100).optional(),
    offset: z.number().min(0).optional(),
    search: z.string().optional(),
    showArchived: z.boolean().optional(),
  }),
  output: z.object({
    items: z.array(
      z.object({
        id: z.number(),
        title: z.string().nullable(),
        createdAt: z.date(),
        updatedAt: z.date(),
        archivedAt: z.date().nullable(),
        isFixed: z.boolean(),
        totalCostUsd: z.number().nullable(),
      }),
    ),
    total: z.number(),
    hasMore: z.boolean(),
  }),
})

export default llmChatListDefinition
